import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { rootRoute } from './root';
import { getSession } from '@/lib/auth-client';
import { CallSurfaceError } from '@/components/route-error';
import { reportRenderError } from '@/lib/rum';

// The manual dialer (plans/callbacks/dialer-v1.md). Session-gated like the cockpit;
// whether this SDR may dial is the BFF/core's answer, rendered by the page itself, so a
// non-rostered SDR sees a sentence rather than a redirect loop. Lazy-loaded so the
// cockpit's chunk never pays for it — and so its Twilio Device is never built beside the
// cockpit's.

function DialGate() {
  const { userEmail } = dialRoute.useRouteContext();
  return <LazyManualDialerPage userEmail={userEmail} />;
}

const LazyManualDialerPage = lazyRouteComponent(() => import('@/manual/ManualDialerPage'));

export const dialRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dial',
  beforeLoad: async () => {
    const { data } = await getSession();
    if (!data) throw redirect({ to: '/login' });
    return { userEmail: data.user.email };
  },
  component: DialGate,
  // Builds a device of its own, so a throw reaching here has already cost the
  // call and this chooses only what replaces it. No operator navigation.
  errorComponent: CallSurfaceError,
  onCatch: (error) => reportRenderError(error, 'route:dial'),
});
